import React from 'react';
import { toast, ToastOptions } from 'react-toastify';

import { Color } from 'types/colors';
import Image from 'components/Image';
import Icon from 'components/Icon';
import { ToastType } from 'components/ui/Toast/Toast';
import { Toast } from 'components/ui/Toast';

interface Props {
    closeToast?: () => void;
    color?: Color;
}

const ToastCloseButton: React.FC<Props> = ({ closeToast, color = 'white' }) => (
    <div onClick={closeToast} style={{ opacity: '0.5', alignSelf: 'center', marginRight: 5 }}>
        <Icon name="cross" color={color} width={18} />
    </div>
);

export const createCustomToast = (
    type: ToastType,
    message: string | React.ReactChild,
    header?: string | React.ReactChild,
    avatar?: string,
    options?: ToastOptions,
): React.ReactNode => {
    const renderToastMessage = () => <Toast type={type} message={message} header={header} />;

    switch (type) {
        case 'info':
            return toast.info(renderToastMessage(), {
                icon: avatar ? <Image src={avatar} toastImage /> : false,
                closeButton: <ToastCloseButton color="black" />,
                ...options,
            });

        case 'warning':
            return toast.warning(renderToastMessage(), {
                icon: <Icon name="exclamation-circle-filled" width={24} />,
                closeButton: <ToastCloseButton />,
                ...options,
            });

        case 'error':
            return toast.error(renderToastMessage(), {
                icon: <Icon name="cross-circle-filled" width={24} />,
                closeButton: <ToastCloseButton />,
                ...options,
            });

        case 'success':
            return toast.success(renderToastMessage(), {
                icon: <Icon name="check-circle-filled" width={24} />,
                closeButton: <ToastCloseButton />,
                ...options,
            });

        default:
            return;
    }
};
